const whyChooseUsData = [
  {
    title: "Nature,\nRecreated with Heart",
    subtitle: "เลียนแบบธรรมชาติ ด้วยใจในทุกรายละเอียด",
    text: "แนวคิดการออกแบบ",
    img: "/Why-Us-01.webp",
    description:
      "ทุกองค์ประกอบในสวนของเราถูกสร้างขึ้นด้วยความพิถีพิถัน เพื่อให้ดูราวกับธรรมชาติได้รังสรรค์ขึ้นเอง ไม่ว่าจะเป็นน้ำตก ลำธาร หรือบ่อปลาที่กลมกลืนไปกับพื้นที่โดยรอบ คุณจะสัมผัสได้ถึงความสงบและเสน่ห์ของธรรมชาติที่แท้จริงในทุกมุมมอง",
  },
  {
    title: "Warmth\nThat Feels Like Home",
    subtitle: "สร้างพื้นที่แสนอบอุ่น ที่สะท้อนความเป็นตัวคุณ",
    text: "แรงบันดาลใจในการสร้างสรรค์",
    img: "/Why-Us-02.webp",
    description:
      "Cozyscape ไม่ได้เพียงแค่สร้างสวน แต่เราสร้างพื้นที่ที่สะท้อนเอกลักษณ์เฉพาะตัวของคุณ พื้นที่ที่เชื่อมโยงกับความรู้สึกของคุณ ให้คุณได้สัมผัสความอบอุ่น สบายใจ และใช้เวลาร่วมกับคนที่คุณรักในบรรยากาศที่ออกแบบมาเพื่อเติมเต็มทุกกิจกรรมและช่วงเวลาสำคัญ",
  },
  {
    title: "Simple to Keep,\nEasy to Love",
    subtitle: "เรียบง่ายในการดูแล แต่เปี่ยมด้วยเสน่ห์ในทุกวัน",
    text: "โครงสร้างและระบบน้ำ",
    img: "/Why-Us-03.webp",
    description:
      "ความสุขจากสวนธรรมชาติไม่ควรเป็นภาระ เราจึงออกแบบทุกโปรเจกต์โดยคำนึงถึงการดูแลรักษาในระยะยาว ใช้วัสดุจริงจากธรรมชาติที่คงทนและกลมกลืนไปกับสภาพแวดล้อม โดยไม่ต้องพึ่งพาการดูแลอย่างเข้มงวดคุณจึงสามารถเพลิดเพลินกับความงามที่แท้จริงของธรรมชาติได้อย่างยั่งยืน",
  },
  {
    title: "Ongoing Care,\nAlways",
    subtitle: "ใส่ใจตั้งแต่เริ่มต้น จนธรรมชาติเติบโตเคียงข้างคุณ",
    text: "บริการดูแล & การรับประกัน",
    img: "/Why-Us-04.webp",
    description:
      "เราดูแลทุกขั้นตอนด้วยหัวใจ ตั้งแต่รับฟังไอเดียและความต้องการของคุณออกแบบงานอย่างใส่ใจในทุกรายละเอียด เพื่อให้ตรงใจและลงตัวกับพื้นที่ติดตั้งด้วยความประณีต พร้อมช่วยแก้ปัญหาและตอบทุกข้อสงสัยของคุณเพราะเรารู้ว่าความงดงามของธรรมชาติ ควรอยู่กับคุณอย่างยั่งยืนและสบายใจ",
  },
];

export default whyChooseUsData;
